import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericLambdaReturn } from '../models/partsWarehouse';
import { PartsServiceUtil } from './parts.service.util';
import { AbstractRestService } from './abstract.rest.service'

@Injectable({
  providedIn: 'root'
})
export class PrepackMetricDetailService extends AbstractRestService{

  displayPrepackMetricDetail(siteId: string):Observable<GenericLambdaReturn<PrePackMetricDetailType[]>> {
    return this.get('/prepackmetricdetail', PartsServiceUtil.buildParams(siteId,null,null,null,null));
  }
}

export type PrePackMetricDetailType = {
  Type: string,
  buildLocation: string,
  minProcess: string,
  minScheduled: string,
  totalOrders: number
}
